import useMutationFlooringCreateUpdate from './flooring-use-mutation-create-update';
import useMutationFlooringDelete from "./flooring-use-mutation-delete";


export const flooringUseMutation = {
  createUpdate: useMutationFlooringCreateUpdate,
  delete: useMutationFlooringDelete,
};